import type { GridColumnVisibilityModel } from '@mui/x-data-grid-premium';
import { getNestedValue } from 'src/core/settings/settings';

export function getTableViewState(settings: unknown, tableName: string) {
  // The default view exists without writing preferences merely by opening a table.
  const views: Record<string, TableView> = { '0': DEFAULT_VIEW, ...getNestedValue(settings, ['TableColumnVisibility', tableName], {}) };
  const requestedId = String(getNestedValue(settings, ['CurrentTableView', tableName], '0'));
  const activeViewId = views[requestedId] ? requestedId : '0';
  return { views, activeViewId, activeView: views[activeViewId] };
}

export function resolveColumnVisibility(model: GridColumnVisibilityModel | null | undefined, defaults: GridColumnVisibilityModel = EMPTY_VISIBILITY) {
  // An explicit {} means all visible. Only missing/null follows application defaults.
  return model ?? defaults;
}

export function snapshotColumnVisibility(columns: readonly { field: string }[], model: GridColumnVisibilityModel): GridColumnVisibilityModel {
  return { ...Object.fromEntries(columns.map(({ field }) => [field, model[field] !== false])), ...model };
}

export const EMPTY_VISIBILITY: GridColumnVisibilityModel = {};

const DEFAULT_VIEW: TableView = { NameActive: 'Default', NameSaved: 'Default', Active: null, Saved: null };

export interface TableView {
  NameActive?: string;
  NameSaved?: string;
  Active?: GridColumnVisibilityModel | null;
  Saved?: GridColumnVisibilityModel | null;
}
